import axios from 'axios'
import create from 'zustand'
import { persist } from 'zustand/middleware'
import Cookies from 'js-cookie'

let store = (set) => ({
  
  admin: {},
  admins: {},
  getAdmin: async () => {
    let token = Cookies.get('token')
    const id = Cookies.get('type')?.substring(40)?.split(',')?.[0] ?? -1

    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
    const apiResponse = await axios.get(
      `${process.env.REACT_APP_API}/admin/${id}`,
      config
    )
    set(async (state) => {
      state.admin = apiResponse.data
    })
  },
  getadmins: async () => {
let token = Cookies.get('token')

const config = {
  headers: {
    Authorization: 'Bearer ' + token,
  },
}
const apiResponse = await axios.get(`${process.env.REACT_APP_API}/admin`, config)
set(async (state) => {
  state.admins = apiResponse.data
})
  },
  addadmin: async (payload) => {
    let token = Cookies.get('token')

    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    const apiResponse = await axios.post(`${process.env.REACT_APP_API}/admin`, payload, config)
    if (apiResponse?.status === 201) {
      set(async (state) => {
        state.admins = {
          data: [...state.admins.data, apiResponse.data],
          limit: state.admins.limit,
          page: state.admins.page,
          totalCount: state.admins.totalCount + 1,
        }
      })
    }
  },
  loginAdmin: async (payload) => {

    const apiResponse = await axios.post(`${process.env.REACT_APP_API}/adminauth/adminlogin`, payload)
    if (apiResponse?.status === 201 || apiResponse?.status == 200) {
      set(async (state) => {
        state.admin = apiResponse?.data?.admin ?? ''
        // state.admin.token= apiResponse?.data?.token?? 'null'

        const adminResult = apiResponse?.data?.admin ?? ''
        const adminId = adminResult?.id ?? ''
        const token = apiResponse?.data?.token ?? ''

        Cookies.set('token', token, {
          httpOnly: false,
          expires: 1,
          secure: true,
          sameSite: 'strict',
          path: '/',
        })
        Cookies.set('type', process.env.REACT_APP_AL + adminId + ',', {
          httpOnly: false,
          expires: 1,
          secure: true,
          sameSite: 'strict',
          path: '/',
        })
        Cookies.set('image', adminResult?.image ?? '', {
          httpOnly: false,
          expires: 1,
          secure: true,
          sameSite: 'strict',
          path: '/',
        })
        Cookies.set('name', adminResult?.name ?? '', {
          httpOnly: false,
          expires: 1,
          secure: true,
          sameSite: 'strict',
          path: '/',
        })
      })
    }
    return apiResponse?.data ?? ''
  },
  logoutAdmin: async () => {
    set(async (state) => {
      state.admin = {}
      Cookies.set('token', '', {
        httpOnly: false,
        expires: 1,
        secure: true,
        sameSite: 'strict',
        path: '/',
      })
      Cookies.set('type', '', {
        httpOnly: false,
        expires: 1,
        secure: true,
        sameSite: 'strict',
        path: '/',
      })
    })
  },
  putadmin: async (payload, id) => {
    let token = Cookies.get('token')

    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    const apiResponse = await axios.patch(`${process.env.REACT_APP_API}/admin/${id}`, payload, config)
    if (apiResponse?.status === 200) {
      set(async (state) => {
        for (let index = 0; index < state.admins.data.length; index++) {
          const element = state.admins.data[index];
          if (element.id == id)
            state.admins.data[index] = apiResponse.data
        }
      })
    }
  },
  deleteadmin: async (id) => {
    let token = Cookies.get('token')

    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    const apiResponse = await axios.delete(`${process.env.REACT_APP_API}/admin/${id}`, config)
    if (apiResponse?.status === 200) {

      set(async (state) => {
        const arr = state.admins.data.filter(item => item.id !== id)
        state.admins = {
          data: arr,
          limit: state.admins.limit,
          page: state.admins.page,
          totalCount: state.admins.totalCount - 1,
        }
      })
    }
  },
})

// store = persist(store, { name: 'admin' })

const admin_Store = create(store)

export default admin_Store
